module.exports = __webpack_public_path__ + "static/media/no_company_logo.5d746bf2.png";